module.exports = {
  "zones": {
    "Pacific/Truk": ["z", {
      "wallclock": -770601600000,
      "format": "+10",
      "abbrev": "+10",
      "offset": 36000000,
      "posix": -770634000000,
      "save": 0
    }, {
      "wallclock": -907372800000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -907408800000,
      "save": 0
    }, {
      "wallclock": -1606780800000,
      "format": "+10",
      "abbrev": "+10",
      "offset": 36000000,
      "posix": -1606813200000,
      "save": 0
    }, {
      "wallclock": -1743638400000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -1743674400000,
      "save": 0
    }, {
      "wallclock": -2177452800000,
      "format": "+10",
      "abbrev": "+10",
      "offset": 36000000,
      "posix": -2177489228000,
      "save": 0
    }, {
      "wallclock": -3944678400000,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 36428000,
      "posix": -3944628428000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -49972000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};